import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const COOKIE_CONSENT_KEY = "qualideco_cookie_consent";

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay to not show immediately on page load
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
          data-testid="cookie-consent"
        >
          <div className="max-w-4xl mx-auto bg-white rounded-sm shadow-2xl border border-gray-100 p-6">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
              {/* Icon */}
              <div className="flex-shrink-0 bg-[#F8F9FA] p-3 rounded-full">
                <Cookie size={28} weight="duotone" className="text-[#E74C3C]" />
              </div>

              {/* Text */}
              <div className="flex-1">
                <h3 className="font-bold text-[#333333] mb-1">
                  🍪 Ce site utilise des cookies
                </h3>
                <p className="text-[#64748B] text-sm">
                  Nous utilisons des cookies pour améliorer votre expérience de navigation et analyser le trafic du site. 
                  En continuant, vous acceptez notre{" "}
                  <Link 
                    to="/politique-confidentialite" 
                    className="text-[#1B93A4] hover:underline"
                  >
                    politique de confidentialité
                  </Link>.
                </p>
              </div>

              {/* Buttons */}
              <div className="flex items-center gap-3 w-full md:w-auto">
                <Button
                  onClick={declineCookies}
                  variant="outline"
                  className="flex-1 md:flex-none border-gray-300 text-[#64748B] hover:bg-gray-100"
                  data-testid="cookie-decline-btn"
                >
                  Refuser
                </Button>
                <Button
                  onClick={acceptCookies}
                  className="flex-1 md:flex-none bg-[#E74C3C] hover:bg-[#C0392B] text-white font-semibold"
                  data-testid="cookie-accept-btn"
                >
                  Accepter
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
